import {
  AccountDetails,
  AccountStatus,
  UserDetails,
  UserInterface,
} from "../types";

export const mockUser: UserDetails = {
  sid: "US67c558d46e4c666b42955",
  active: 1,
  userType: 0,
  currentAccountSid: "AC648d937704b94309822578b85",
  emailAddr: "crobot@twilio.com",
  firstName: "Cedric",
  lastName: "Robot",
  friendlyName: "crobot@twilio.com",
  isoCountryCode: "US",
  emailValidated: true,
  preferredLanguage: "en",
  flags: [],
  dateCreated: "2020-08-10T13:12:22",
  dateUpdated: "2024-08-06T14:01:29",
};

export const mockAccount: AccountDetails = {
  active: 1,
  currentAccountSid: "AC648d937704b94309822578b85",
  dateCreated: "2012-04-27T12:07:59-07:00",
  dateUpdated: "2024-08-07T12:59:41-07:00",
  sid: "AC648d937704b94309822578b85ff1227f",
  emailAddr: "crobot@twilio.com",
  emailValidated: true,
  firstName: "Cedric",
  lastName: "Robot",
  friendlyName: "crobot@twilio.com",
  flags: [1, 4, 7, 9, 11, 16],
  status: AccountStatus.active,
  version: 4751,
  upgraded: true,
  userType: 0,
  preferredLanguage: "en",
  isoCountryCode: "US",
};

export const mockUserProviderContext: UserInterface = {
  account: mockAccount,
  doesPageRequireLogin: false,
  hasAccountSwitcherError: false,
  isLoggedIn: true,
  isLoading: false,
  isLoadingAccountSwitcher: false,
  isLoadingSubaccounts: false,
  isOnSubaccount: false,
  appliedSubaccountFilters: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setAppliedSubaccountFilters: () => {},
  updateCurrentAccountSid: () => Promise.resolve(false),
  user: mockUser,
};
